import { render, staticRenderFns } from "./InvestedProjectCard.vue?vue&type=template&id=42b26202&scoped=true&"
import script from "./InvestedProjectCard.vue?vue&type=script&lang=js&"
export * from "./InvestedProjectCard.vue?vue&type=script&lang=js&"
import style0 from "./InvestedProjectCard.vue?vue&type=style&index=0&id=42b26202&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b26202",
  null
  
)

export default component.exports